module.exports = __webpack_public_path__ + "static/img/kl1400-fcm-sdw375-75bb.256b183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kl1400-fcm-sdw375-75bb.jpg
// module id = i8Wl
// module chunks = 0